import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringToColor',
    standalone: true
})
export class StringToColorPipe implements PipeTransform {
    transform(value?: string, fallback: string = 'f1f1f1'): string {
        return value ? (value.includes('#') ? value : `#${value}`) : `#${fallback}`;
    }
}
